// src/context/AppContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';

export const AppContext = createContext();

const getBrowserLang = () => {
  const lang = navigator.language?.split('-')[0] || 'en';
  const ruRegions = ['ru', 'uk', 'be', 'kk', 'hy', 'az', 'ka', 'tg', 'uz', 'tk', 'ky', 'mo', 'tt'];
  return ruRegions.includes(lang) ? 'ru' : 'en';
};

const getInitialTheme = () => {
  const saved = localStorage.getItem('theme');
  if (saved) return saved;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export const useTranslation = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useTranslation must be used inside AppProvider. Check index.js');
  }
  return { t: context.t, lang: context.lang, toggleLang: context.toggleLang };
};

export const useTheme = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useTheme must be used inside AppProvider. Check index.js');
  }
  return { theme: context.theme, toggleTheme: context.toggleTheme };
};

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('lang') || getBrowserLang();
  });

  const [theme, setTheme] = useState(() => getInitialTheme());

  useEffect(() => {
    localStorage.setItem('lang', lang);
  }, [lang]);

  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  const toggleLang = () => setLang(prev => prev === 'ru' ? 'en' : 'ru');
  const toggleTheme = () => setTheme(prev => prev === 'light' ? 'dark' : 'light');

  const translations = require('../translations').translations[lang];

  // 👇 Логируем, что контекст инициализирован
  console.log('[AppProvider] Context initialized:', { lang, theme });

  return (
    <AppContext.Provider value={{ lang, toggleLang, t: translations, theme, toggleTheme }}>
      {children}
    </AppContext.Provider>
  );
};